module.exports = "<div class=\"row\">\n  <div class=\"col-md-6\">\n    <h3><span>{{t.label}}</span>{{price}}</h3>\n  </div>\n</div>\n"